import { NavLink } from 'react-router'
import styles from './Sidebar.module.css'

interface SidebarLink {
  icon: string
  label: string
  url?: string
  target?: string
  onClick?: () => void
  isActive?: boolean
}

export function Link({ icon, label, url, target, onClick, isActive }: SidebarLink) {
  const hasUrl = typeof url === 'string' && url.trim() !== ''

  if (hasUrl) {
    return (
      <div className={styles.link}>
        <NavLink
          to={url}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          className={({ isActive: navIsActive }) => `no-underline text-500 ${navIsActive ? 'text-cyan-500 font-bold' : ''}`}
          onClick={onClick}
        >
          <i className={`pi ${icon} mr-2`}></i>
          {label}
        </NavLink>
      </div>
    )
  }

  return (
    <div className={styles.link}>
      <button
        type="button"
        onClick={onClick}
        className={`p-0 border-none bg-transparent text-500 text-base ${
          isActive ? 'text-cyan-500 font-bold' : ''
        }`}
      >
        <i className={`pi ${icon} mr-2`}></i>
        {label}
      </button>
    </div>
  )
}
